import EligibleOffer from './EligibleOffer';
import IneligibleOffer from './IneligibleOffer';
import InstantOffersForm from './InstantOffersForm';
import { IInstantOffersFormData } from './InstantOffersContainer';
import CoverSection from '../CoverSection/CoverSection';
import { EventHandler } from 'react';

export interface IInstantOfferDetails {
    onStartNewOffer: EventHandler<any>;
    vehicleMake?: string;
    vehicleModel?: string;
}

interface IInstantOffersProps {
    savedOffer: any;
    hasInvalidLicensePlate: boolean;
    hasSavedEligibleOffer: boolean;
    hasSavedIneligibleOffer: boolean;
    onSubmit: (event: any, formData: IInstantOffersFormData) => any;
    instantOfferDetails: IInstantOfferDetails;
}

const InstantOffers = (props: IInstantOffersProps) => {
    if (props.hasSavedEligibleOffer) {
        return (
            <CoverSection noPaddingMobile>
                <EligibleOffer
                    offerAmount={props.savedOffer.offerAmount}
                    expirationDateUtc={props.savedOffer.expirationDateUtc}
                    expirationDisplayDate={props.savedOffer.expirationDisplayDate || props.savedOffer.expirationDateUtc}
                    offerCode={props.savedOffer.offerCode}
                    storeId={props.savedOffer.storeId}
                    instantOfferDetails={props.instantOfferDetails}
                />
            </CoverSection>
        );
    }

    if (props.hasSavedIneligibleOffer) {
        return (
            <CoverSection noPaddingMobile>
                <IneligibleOffer instantOfferDetails={props.instantOfferDetails} />
            </CoverSection>
        );
    }

    return (
        <CoverSection noPaddingMobile>
            <InstantOffersForm hasInvalidLicensePlate={props.hasInvalidLicensePlate} onSubmit={props.onSubmit} />
        </CoverSection>
    );
};

export default InstantOffers;
